import { Button } from "@amzn/awsui-components-react/polaris";
import {populateReportingPeriod} from "../utils/Utils"
import {TRANSACTION_DETAIL_INFO} from "../../../common/constants/constants";
import {
    changePagedRowsPage,
    failPagedRows,
    initializePagedRows,
    PAGE_FETCH_FAILED_MESSAGE,
    PAGED_ROWS_INITIAL_STATE,
    receivePagedRows,
    reloadPagedRows,
    sortPagedRows
} from "../../../common/pagination/pagedRows";

// One dismissible message; `dispatcher` is this reducer's own dispatch, which the dismiss needs.
const flashBarItemFor = ({msg, type, dispatcher, handleFlashBarAction}) => {
    const buttonCTA = type === 'success' ? 'Continue Filing' : 'Retry';
    return [{
        type,
        action: handleFlashBarAction ? <Button onClick={handleFlashBarAction}>{buttonCTA}</Button> : null,
        dismissible: true,
        dismissLabel: "Dismiss message",
        onDismiss: () => dispatcher({ type: "DISMISS_FLASHBAR", payload: {} }),
        content: (
            <>
                {msg}
            </>
        ),
        id: "message_1"
    }];
};

export const INITIAL_STATE = {
    ...PAGED_ROWS_INITIAL_STATE,
    data: [],
    reportingPeriod: null,
    periodList: [],
    loadingText: "Loading requests",
    filePath: {},
    flashBarItem: [],
    submitted: false,
    fileSummaryData : null
};

export const filingReducerInit = initialState => {
    return initialState;
}

// Which list this reducer instance pages: the filing audit list, or one transaction's task rows.
const rowKeyFor = ({tableContext}) => tableContext === TRANSACTION_DETAIL_INFO ? "taskId" : "transactionId";

// Only updates state: the page fetch each action asks for is made by FilingTable (usePagedRowsFetch).
export const filingReducer = (state, action) => {
    switch (action.type) {
        case "INITIALIZE_AUDIT":
            return initializePagedRows(state);
        case "API_RESPONSE":
            return receivePagedRows(state, action.payload, rowKeyFor(action.payload));
        case "CREATE_FILE_PATH_SUCCESS":
            return {
                ...state,
                filePath: action.payload?.data
            }
        case "TRANSMIT_FILE_REQUEST_COMPLETED": {
            const next = action.payload.fetchAudit ? reloadPagedRows(state) : state;
            return {
                ...next,
                submitted: true
            }
        }

        case "SET_FLASH_BAR":
            window.scrollTo(0,0);
            return {
                ...state,
                flashBarItem: flashBarItemFor(action.payload)
            }
        case "AUDIT_FETCH_FAILED": {
            const next = failPagedRows(state, action.payload);
            if (next === state) {
                return state;
            }
            return {
                ...next,
                flashBarItem: flashBarItemFor({msg: PAGE_FETCH_FAILED_MESSAGE, type: 'error', dispatcher: action.payload.dispatcher})
            }
        }
        case "FAILURE_API_RESPONSE":
            return {
                ...state,
                initialize: false,
            }
        case "AUTH_UPDATE":
            console.log(action.payload)
            return {
                ...state,
                isUserAuthenticatedWithTaxAuthority : action.payload.isUserAuthenticatedWithTaxAuthority
            }
        case "SET_AUTH_CODE":
            return {
                ...state,
                authCode: action.payload?.data
            }
        case "SET_REPORTING_PERIOD":
            const data = populateReportingPeriod(action.payload?.periodList);
            return {
                ...state,
                reportingPeriod: data,
                periodList: action.payload?.periodList
            }
        case "DISMISS_FLASHBAR":
            return {
                ...state,
                flashBarItem: []
            }
        
        case "PAGE_INDEX_CHANGED":
            return changePagedRowsPage(state, action.payload.pageIndex);
        case "RESET_STATE": 
            return {
                ...state,
                periodList : action.payload.periodList,
                filePath : action.payload.filePath,
                fileSummaryData : action.payload.fileSummaryData,
                flashBarItem : action.payload.flashBarItem,
                submitted : action.payload.submitted,
                reportingPeriod : action.payload.reportingPeriod
            } 
        case "SET_SUMMARY_DATA": 
            return {
                ...state,
                fileSummaryData : action.payload.fileSummaryData
            }  
        case "AUDIT_SORTING_CHANGED":
            return sortPagedRows(state, action.payload);
        case "REFRESH_AUDIT":
            return reloadPagedRows(state);

        default:
            return state;
    }
}
